<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
<!--    <keep-alive>-->
<!--      <router-view v-if="isRouterAlive && $route.meta.keepAlive"></router-view>-->
<!--    </keep-alive>-->
<!--    <router-view v-if="isRouterAlive && !$route.meta.keepAlive"></router-view>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted () {
    this.getSelf()
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    getSelf () {

    },
  }
}

</script>

<style>
@import "../static/font/iconfont.css";
@import "../static/style/base.css";

#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  /* height: 100%; */
  width: 100%;
}

* {
  margin: 0;
  padding: 0;
}

.pointer {
  cursor: pointer;
}
input {
  padding-left: 10px;
}
.w377 {
  width: 377px !important;
}
.w403 {
  margin-top: 20px;
  width: 403px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue